var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 16L7 16L7 5.46484L6.04492 6.41992L5.51758 5.89258L7.375 4.03516L9.23242 5.89258L8.70508 6.41992L7.75 5.46484L7.75 16ZM11.2949 13.5801L12.25 14.5352L12.25 4L13 4L13 14.5352L13.9551 13.5801L14.4824 14.1074L12.625 15.9648L10.7676 14.1074L11.2949 13.5801Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSort);
export default __webpack_public_path__ + "static/media/defaultSort.1c885e399a98baa8591f81249b7dae40.svg";
export { ForwardRef as ReactComponent };